import { FC, PropsWithChildren } from 'react'

import { useMediaQuery } from 'react-responsive'

export const Desktop: FC<PropsWithChildren> = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 577 })

  if (!isNotMobile) {
    return null
  }

  return <>{children}</>
}
